import { RootState } from '../../main/store/main.store.ts';
import { RedirectionItem } from '../../main/types/app-redirection.types.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

interface Props {
  currentPath: string;
}

export const selectAppRedirectionItemTarget = createMemoizedSelector(
  (state: RootState): RedirectionItem[] => state.appRedirection.redirectionItems,
  (_: RootState, props: Props): string => props.currentPath,
  (redirectionItems, currentPath): RedirectionItem | undefined => {
    const firstItem = redirectionItems[0];

    if (!firstItem) {
      return;
    }

    if (firstItem.path.toString() === currentPath) {
      return;
    }

    return firstItem;
  }
);
